import moment from 'jalali-moment';

const TimeDifferenceConvertor = (time: Date | string): string => {
  const today = new Date();
  return moment(moment(new Date(time)))
    .locale('fa')
    .from(today);
};

export default TimeDifferenceConvertor;
